// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__AoxgP","col":"styles_col__1nNTf"};